export default __webpack_public_path__ + "static/media/logo-ana.fff05ad2.png";